let uid = 0;

export default function hotShader(shader, type, cb) {
    const noop = () => {};

    const obj = {
        uid: ++uid,
        shader,
        use,
        unuse: noop,
        clear: noop,
        chunkChangedCalllbacks: new Set()
    };

    function use(el) {
        const instance = el.material || el;
        instance[type] = obj.shader;
        instance.needsUpdate = instance.uniformsNeedUpdate = true;
        return instance;
    }

    if (import.meta.hot) {
        obj.instances = new Set();

        obj.use = (el) => {
            const instance = use(el);
            if (instance.onHotShaderUpdate) instance.onHotShaderUpdate(type, obj.shader);
            obj.instances.add(instance);
            return instance;
        };

        obj.unuse = instance => {
            obj.instances.delete(instance);
        };

        obj.clear = _instance => {
            obj.instances.clear();
        };

        obj.update = newObj => {
            const o = newObj.default;
            o.orig = obj.orig || obj;
            o.orig.shader = o.shader;
            Object.assign(o, o.orig);
            obj.instances.forEach(o.use);
        };

        if (cb) cb(obj.update);
    }

    return obj;
}
